import { render, staticRenderFns } from "./screenSaver.vue?vue&type=template&id=0550ff1b"
import script from "./screenSaver.vue?vue&type=script&lang=js"
export * from "./screenSaver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports